import { makeStyles } from "@material-ui/core";
import theme from '../theme'
export const categoryStyles = makeStyles({
    buttonStyle: {
    position: 'relative',
    left: '95%',
    height: '10px',
    width: '10px',
    color: theme.palette.primary.main,
    '& svg': {
      height: '10px',
    },
    '& Divider': {
      color: theme.palette.primary.main,
    },
  },
  boxContentStyle: {
    width: '90%',
    marginLeft: '5%',
  },
})
